import React from "react";

const H1 = (props) => {
  const { children, size, classe } = props;

  let textSize;

  if (size === "small") textSize = "text-xl md:text-2xl lg:text-3xl";
  else textSize = "text-4xl md:text-4xl lg:text-5xl";

  return (
    <h1
      className={`
            font-nunito
            font-black
            text-white
            ${textSize}
            ${classe}
        `}
    >
      {children}
    </h1>
  );
};

export default H1;
